import React from "react";
import LGPD from "../../../assets/images/LGPD.png";
import TopSecret from "../../../assets/images/topsecret.png";
import TopSecret2 from "../../../assets/images/topsecret2.png";

import './styles.css';
import { ListGroup } from "react-bootstrap";

const Lgpd = () => {
    return (
        <div className="container">
            <div className="row py-4">
                <div className="title">
                    <h1>Lei Geral de Proteção de Dados - LGPD</h1>
                    <hr />
                </div>
                <div className="col-sm-12 col-md-6">
                    <img src={LGPD} alt="foto" />
                    <h3>
                        A LGPD (Lei Geral de Proteção de Dados) é uma legislação que
                        visa garantir a privacidade e proteção dos dados pessoais dos indivíduos.
                    </h3>
                </div>
                <div className="col-sm-12 col-md-6">

                    <p>
                        A LGPD é uma lei que busca proteger os dados pessoais dos indivíduos,
                        garantindo a privacidade e segurança das informações. É fundamental entender e
                        cumprir as diretrizes dessa legislação para preservar a
                        confiança dos nossos clientes e evitar qualquer violação de dados.
                    </p>
                    <p>
                        A LGPD visa proteger dados pessoais sensíveis, como informações de identificação, endereço,
                        números de telefone, CPF, entre outros.
                        É essencial seguir as diretrizes dessa legislação para evitar exposição indevida desses dados,
                        preservando assim a privacidade e segurança dos nossos clientes.
                    </p>
                </div>
            </div>
            <hr />
            <div className="row py-4">
                <h3>Manual de Orientação para os Colaboradores - Cumprimento da LGPD</h3>
                <br /><br />
                <div className="header">
                    <span>
                        Com o intuito de proteger os dados pessoais dos nossos clientes, garantindo a privacidade e segurança das informações, desenvolvemos este Manual de Orientação para o Cumprimento da Lei Geral de Proteção de Dados (LGPD). É fundamental que cada um de nós compreenda e siga as diretrizes estabelecidas neste documento para preservarmos a confiança dos nossos clientes e evitarmos qualquer violação de dados.
                    </span>
                    <br /><br />
                    <span>
                        A LGPD visa proteger dados pessoais sensíveis, tais como informações de identificação, endereço, números de telefone, CPF, entre outros. Abaixo, apresentamos os principais pontos que devemos seguir rigorosamente:
                    </span>
                    <br /><br />
                </div>
                <div className="col-sm-12 col-md-8">
                    <div className='quest'>
                        <ListGroup>

                            <ListGroup.Item>
                                <span>
                                    1. Conscientização e Treinamento:
                                </span>
                                <p>
                                    Todos os colaboradores devem participar de treinamentos sobre a LGPD, compreendendo a importância da proteção de dados e as diretrizes a serem seguidas. Mantenha-se atualizado(a) e esteja ciente do papel crucial que desempenhamos na proteção dos dados dos nossos clientes.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    2. Coleta de Dados:
                                </span>
                                <p>
                                    Lembre-se de que os dados pessoais dos clientes só podem ser coletados mediante o consentimento explícito e para fins específicos e legítimos. Certifique-se de explicar claramente o propósito da coleta de dados aos nossos clientes.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    3. Armazenamento Seguro:
                                </span>
                                <p>
                                    Zele pela segurança dos dados pessoais, garantindo que sejam armazenados em locais seguros e protegidos contra acesso não autorizado. Acesso aos dados deve ser restrito apenas a colaboradores autorizados.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    4. Tratamento de Dados:
                                </span>
                                <p>
                                    Os dados pessoais devem ser tratados somente para os fins autorizados pelos clientes e de acordo com o consentimento concedido. É estritamente proibido o uso dos dados para outros fins não autorizados.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    5. Compartilhamento de Dados:
                                </span>
                                <p>
                                    O compartilhamento de dados com terceiros deve ser realizado de forma segura e de acordo com contratos que estabeleçam claramente as responsabilidades de cada parte em relação à proteção dos dados.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    6. Acesso aos Dados pelos Clientes:
                                </span>
                                <p>
                                    Os clientes têm o direito de acessar seus dados pessoais e solicitar correções ou exclusão, quando necessário. Estamos aqui para ajudar, então encaminhe essas solicitações ao setor responsável com a máxima agilidade.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    7. Gerenciamento de Incidentes:
                                </span>
                                <p>
                                    Caso ocorra algum incidente de segurança que possa comprometer os dados pessoais, comunique imediatamente a equipe de gestão, para que possamos tomar as medidas necessárias para solucionar o problema e notificar os clientes afetados.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    8. Política de Retenção:
                                </span>
                                <p>
                                    Certifique-se de seguir a política de retenção de dados, determinando por quanto tempo os dados pessoais serão armazenados, sempre considerando as exigências legais e os propósitos da coleta.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    9. Auditorias e Monitoramento:
                                </span>
                                <p>
                                    Estejamos atentos e diligentes em relação ao cumprimento das políticas de proteção de dados. Auditorias internas e monitoramentos constantes serão realizados para garantir a conformidade com a LGPD.
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <span>
                                    10. Responsável pela Proteção de Dados (DPO):
                                </span>
                                <p>
                                    Contamos com um Responsável pela Proteção de Dados (DPO) para nos auxiliar no cumprimento da LGPD. Em caso de dúvidas ou necessidade de orientações, sinta-se à vontade para entrar em contato com o DPO.
                                </p>
                            </ListGroup.Item>

                        </ListGroup>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4">
                    <div className="secret">
                    <img src={TopSecret2} alt="foto" />
                    <img src={TopSecret} alt="foto" />
                    </div>
                </div>
            </div>
            <div className="caution">
                <span>
                Nós, colaboradores da Gigabyte Telecom, somos responsáveis por garantir a proteção dos dados pessoais dos nossos clientes. Ao cumprirmos com as diretrizes estabelecidas neste Manual, reforçamos o compromisso da empresa com a privacidade e segurança das informações. O descumprimento das políticas e procedimentos pode acarretar consequências legais e danos à reputação da empresa.
                </span>
                <br /><br />
                <h3>
                Contamos com o seu comprometimento e cooperação para tornar a Gigabyte Telecom referência em excelência na proteção de dados.
                </h3>
                <br /><br />
            </div>
        </div>
    );
}
export default Lgpd;